export default __webpack_public_path__ + "static/media/tenex.1919227d.png";